<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="forgetPassword"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/forgetPass.png"
                alt="login"
                class="forget-img"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h2 class="header"><b>Forgot Your Password</b></h2>
                </div>
                <ValidationObserver ref="observer">
                  <div>
                    <div class="input-field">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="username"
                      >
                        <vs-input
                          name="username"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          placeholder="Enter UserName"
                          v-model="username"
                          class="w-3/4 ml-4 mb-2"
                        />
                        <span class="validate-error ml-4" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                      <vs-button
                        class="submit-button"
                        @click.stop="getverifyusername"
                      >
                        {{ $t("Submit") }}
                      </vs-button>
                    </div>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      email: "",
      username: "",
      message: "",
    };
  },
  computed: {
    ...mapState({
      verUsername: (state) => state.dashboard.username,
    }),
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    async getverifyusername() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        await this.$store.dispatch(
          "dashboard/setverifyusername",
          this.username
        );
        this.$router.push("/forgetEmail");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
#forgetPassword {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
.forget-img {
  height: 290px;
}
.input-field {
  margin-left: 2rem;
}
.submit-button {
  margin-top: 3rem;
  margin-left: 7rem;
  margin-bottom: 20px;
}
.header {
  margin-left: 10px;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
